import { errorlog } from '@/libs/error-logs';
import { toast_error } from '@/libs/toast-wrappers';
import { ERROR_FETCH_USERS } from '@/utils/messages';
import { ROLES } from '@/utils/constants';
import { toError } from '@/utils/errors';

import { GET, PUT } from './base/index';
import { ENDPOINTS } from './endpoints';
import { StandardResponse } from './standard-response';

export type User = {
  user_email: string;
  email?: string; // Keep for backward compatibility
  full_name?: string;
  contact_phone?: string;
  role?: ROLES;
  clinic_id?: string;
  clinic_name: string;
  city?: string;
  country?: string;
  street_address?: string;
  province_or_state?: string;
  postal_code?: string;
};

export type UpdateUserData = {
  email: string;
  full_name: string;
  contact_phone?: string;
  role: ROLES;
  clinic_id: string;
};

export async function getUsersList(clinic_id: string) {
  try {
    const response = await GET<StandardResponse<User[]>>(ENDPOINTS.USERS_LIST, {
      query: { clinic_id },
    });
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/users/getUsersList', 'Error fetching users');
    toast_error(ERROR_FETCH_USERS);
    return Promise.reject(toError(error));
  }
}

export async function updateUser(email: string, data: UpdateUserData) {
  try {
    const response = await PUT<StandardResponse<User>>(ENDPOINTS.USERS_UPDATE, data, {
      parameters: { email },
    });
    return response.data;
  } catch (error) {
    errorlog(error as Error, 'src/api/users/updateUser', 'Error updating user');
    toast_error('Error updating user. Please try again.');
    return Promise.reject(toError(error));
  }
}
